import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UIService } from '../services/ui.service';
import * as UIActions from './ui.actions';

@Injectable({
  providedIn: 'root'
})
export class UIEffects {
  private actions$ = inject(Actions);
  private uiService = inject(UIService);

  scrollToElement$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(UIActions.ScrollToElement),
      map(({ selector }) => selector),
      switchMap((selector) =>
        this.uiService.scrollToElement(selector).pipe(
          map(() => UIActions.ScrollToElementSuccess()),
          catchError(() => of(UIActions.ScrollToElementFailed()))
        )
      )
    );
  });
}
